


















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { DateOption } from '@/features/reports/models';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import ProactiveTriggersTrendChart from '@/features/reports/components/usage/ProactiveTriggersTrendChart.vue';
import BillableConversationsTrendChart from '@/features/reports/components/usage/BillableConversationsTrendChart.vue';
import ChannelMessagesTrendChart from '@/features/reports/components/usage/ChannelMessagesTrendChart.vue';
import { usageReportsApi, UsageReportsData } from '@/features/reports/services/usageReportsApi';
import { DatePicker } from '@/features/reports/services';

@Component({
	mixins: [],
	components: {
		ProactiveTriggersTrendChart,
		BillableConversationsTrendChart,
		ChannelMessagesTrendChart
	},
})
export default class UsageReports extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public selectedDateOption!: DateOption;

	@Mutation(SET_REPORT_LOADING) public setLoading: (loading: boolean) => void;

	public chartData: UsageReportsData = {
		proactiveTriggersTrendReport: {
			scale: {
				title: '',
				labels: []
			},
			series: []
		},
		billableConversationsTrendReport: {
			scale: {
				title: '',
				labels: []
			},
			series: []
		},
		channelMessagesTrendReport: {
			scale: {
				title: '',
				labels: []
			},
			series: []
		},
	};

	public loadingError: boolean = false;
	public loadedData: boolean = false;

	@Watch('selectedDateOption', { immediate: true })
	public async onFilterChange(filter: DateOption, previous: DateOption) {
		if (filter && filter === previous) {
			return;
		}

		await this.loadData();
	}

	private async loadData() {
		if (!DatePicker.isValidMonthOption(this.selectedDateOption)) {
			return; // Invalid selection, will be corrected in the date filter and this will be called again
		}

		this.loadedData = false;
		this.loadingError = false;
		this.setLoading(true);
		try {
			this.chartData = await usageReportsApi.loadData(this.currentWorkspace.id, {
				startDate: this.selectedDateOption.getDateRange().start,
				endDate: this.selectedDateOption.getDateRange().end
			});
			this.loadedData = true;
		} catch {
			this.loadingError = true;
		} finally {
			this.setLoading(false);
		}
	}
}
